<template>
  <b-card
    border-variant="warning"
    title="Daily Parking"
  >
    <b-card-text>
      Pay for daily parking
    </b-card-text>
    <b-button
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      v-b-modal.initiate-payment
      variant="outline-warning"
    >
      <feather-icon
        icon="DollarSignIcon"
        class="mr-50"
      />
      <span class="align-middle">Pay</span>
    </b-button>
    <!-- modal -->
    <b-overlay
      :show="showWaitingPayment"
      rounded="sm"
    >
      <b-modal
        id="initiate-payment"
        ref="my-modal"
        title="Pay for parking"
        ok-title="Pay"
        cancel-variant="outline-secondary"
        centered
        @show="resetModal"
        @hidden="resetModal"
        @ok="handleSubmit"
      >
        <validation-observer ref="simpleRules">
          <statistic-card-horizontal
            :class="{ hide: !showOtherDetails }"
            icon="DollarSignIcon"
            color="success"
            variant="light-success"
            :statistic="'Amount to Pay - KES ' + amountToPay"
          />
          <form
            ref="form"
            @submit.stop.prevent="handleSubmit"
          >
            <b-form-group
              label="Vehicle Type"
              label-for="vehicleType"
            >
              <validation-provider
                #default="{ errors }"
                name="Vehicle Type"
                rules="required"
              >
                <v-select
                  id="vehicleType"
                  v-model="vehicleType"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="name"
                  :options="vehicleTypeOptions"
                  :@change="calculateServicePrice()"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group
              label="Collection Center"
              label-for="collectionCenter"
            >
              <validation-provider
                #default="{ errors }"
                name="Collection Center"
                rules="required"
              >
                <v-select
                  id="collectionCenter"
                  v-model="collectionCenter"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="name"
                  :options="collectionCenterOptions"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <!-- Reg No -->
            <div
              :class="{ hide: !showOtherDetails }"
            >
              <b-form-group
                label="Reg No"
                label-for="regNo"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Reg No"
                  rules="required"
                >
                  <b-form-input
                    id="regNo"
                    v-model="regNo"
                    type="text"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Reg No"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- Phone No -->
              <b-form-group
                label="Phone No"
                label-for="phoneNo"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Phone No"
                  rules="required"
                >
                  <b-form-input
                    id="phoneNo"
                    v-model="phoneNo"
                    type="text"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Phone No"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </div>
          </form>
        </validation-observer>
      </b-modal>
    </b-overlay>
  </b-card>
</template>

<script>
import {
  BCard, BCardText, BButton, BFormGroup, BFormInput, BModal, VBModal, BOverlay,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import appUtils from '@/auth/jwt/useJwt'
import { required } from '@validations'
import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue'

export default {
  components: {
    BCard,
    BCardText,
    BButton,
    BFormGroup,
    BFormInput,
    BModal,
    BOverlay,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    StatisticCardHorizontal,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      showWaitingPayment: false,
      regNo: null,
      vehicleType: null,
      phoneNo: null,
      submittedNames: [],
      vehicleTypeOptions: [{ id: 1, name: 'Private' }, { id: 2, name: 'Pick Up' }, { id: 3, name: 'Nissan/PSV' }, { id: 4, name: 'Canter' }, { id: 5, name: 'Lorry' }, { id: 6, name: 'Bus' }, { id: 7, name: 'Trailer' }],
      collectionCenter: null,
      collectionCenterOptions: [],
      required,
      connection: null,
      showOtherDetails: false,
      amountToPay: 0,
    }
  },
  mounted() {
    this.fetchCollectionCenters()
  },
  methods: {
    calculateServicePrice() {
      if (this.vehicleType != null && this.collectionCenter != null) {
        appUtils.fetchServicePrice({
          serviceId: this.vehicleType.id,
          type: 'parking',
          collectionCenter: this.collectionCenter.id,
        }).then(response => {
          if (response.data.data > 0) {
            this.showOtherDetails = true
            this.amountToPay = response.data.data
          } else {
            this.$swal({
              title: 'Error!',
              text: 'An error has occurred, please contact the county for assistance',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
          }
        })
      }
    },
    fetchCollectionCenters() {
      appUtils.fetchCollectionCenters().then(response => {
        this.collectionCenterOptions = response.data.data
      })
    },
    resetModal() {
      this.regNo = null
      this.vehicleType = null
      this.collectionCenter = null
      this.phoneNo = null
    },
    handleSubmit(ev) {
      // Prevent modal from closing
      ev.preventDefault()
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          // Trigger submit handler
          // eslint-disable-next-line
          appUtils.payForDailyParking({
            regNo: this.regNo,
            phoneNo: this.phoneNo,
            vehicleType: this.vehicleType.id,
            collectionCenter: this.collectionCenter.id,
          })
            .then(response => {
              if (response.data.status === '00') {
                this.$swal({
                  title: 'Success!',
                  text: response.data.message,
                  icon: 'success',
                  customClass: {
                    confirmButton: 'btn btn-primary',
                  },
                  buttonsStyling: false,
                })
              } else {
                this.$swal({
                  title: 'Error!',
                  text: response.data.message,
                  icon: 'error',
                  customClass: {
                    confirmButton: 'btn btn-primary',
                  },
                  buttonsStyling: false,
                })
              }
            })
        }
      })
    },
  },
}
</script>
<style lang="scss">
  .hide {
    display: none !important;
  }
</style>
